import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
    redirect: '/home',  // 重定向到主页
    children: [
      {
        path: 'about-company',
        name: 'AboutPeiSen',
        meta: { name: '关于培森' },
        component: () => import('../views/AboutCompany'),
        props: route => ({ hash: route.hash }) // 接收 hash 参数
      },
      {
        path: 'cooperate',
        name: 'Cooperate',
        meta: { name: '战略合作' },
        component: () => import('../views/Cooperate')
      },
      {
        path: 'text',
        name: 'text',
        meta: { name: '富文本' },
        component: () => import('../views/Text')
      },
      {
        path: 'jobDetail',
        name: 'jobDetail',
        meta: { name: '富文本' },
        component: () => import('../views/JobDetail')
      },
      
      { 
        path: 'home', 
        name: 'Home', 
        meta: { name: '系统首页' }, 
        component: () => import('../views/Home') 
      },
      { 
        path: 'energy', 
        name: 'Energy', 
        meta: { name: '新能源' }, 
        component: () => import('../views/component/New/Energy/NewEnergy'),
      },
      { 
        path: 'build', 
        name: 'Build', 
        meta: { name: '新基建' }, 
        component: () => import('../views/component/New/Build/NewBuild'),
      },
      { 
        path: 'Medium', 
        name: 'Medium', 
        meta: { name: '新装备' }, 
        component: () => import('../views/component/New/Media/NewMedium'),
      },
      { 
        path: 'numWisdom', 
        name: 'numWisdom', 
        meta: { name: '新数智' }, 
        component: () => import('../views/component/New/NumWisdom/NewNumWisdom'),
      },
      {
        path: 'learnMoreEnergy/:id',
        name: 'LearnMoreEnergy',
        meta: { name: '新能源了解更多' },
        component: () => import('../views/component/New/Energy/LearnMore')
      },
      {
        path: 'learnMoreBuild/:id',
        name: 'LearnMoreBuild',
        meta: { name: '新基建了解更多' },
        component: () => import('../views/component/New/Build/LearnMore')
      },
      {
        path: 'learnMoreMedium/:id',
        name: 'LearnMoreMedium',
        meta: { name: '新装备了解更多' },
        component: () => import('../views/component/New/Media/LearnMore')
      },
      {
        path: 'learnMoreNumWisdom/:id',
        name: 'LearnMoreNumWisdom',
        meta: { name: '新数智了解更多' },
        component: () => import('../views/component/New/NumWisdom/LearnMore')
      },
      {
        path: 'productCenter',
        name: 'ProductCenter',
        meta: { name: '产品中心' },
        component: () => import('../views/component/ProductCenter/index')
      },
      {
        path: 'productDetail/:id',
        name: 'ProductDetail',
        meta: { name: '产品详情' },
        component: () => import('../views/component/ProductCenter/ProductDetail/index')
      },
      {
        path: 'job/:id',
        name: 'JobDetail',
        meta: { name: '岗位详情' },
        component: () => import('../views/component/JobDetail.vue')
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
        offset: { x: 0, y: 80 } // 调整偏移量以匹配导航栏高度
      };
    }
    // 导航栏 query 跳转
    if (to.query && to.query.type) {
      return {
        selector: `#${to.query.type}`,
        behavior: 'smooth',
        offset: { x: 0, y: 80 }
      };
    }
    if (to.query && to.query.id) {
      return {
        selector: `#${to.query.id}`,
        behavior: 'smooth',
        offset: { x: 0, y: 80 }
      };
    }
    return { x: 0, y: 0 };
  }
});

export default router
